import 'es6-promise/auto'

import Vue from 'vue'
import App from './App'
import router from './router'
// import store from '../shared/store/store'
import service from '../shared/service/service'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//css
import '../shared/assets/css/base.css'

//私有平台 - 公用组件
import footerTab from './components/bottom'
import head from './components/header'


//跨平台 - 公用组件 - 页面组件
//服务人员详情
import serverDetail from '../shared/components/server/server-detail.vue' //阿姨详情 - 简历、历史评价、历史订单
import serverDetailFooter from '../shared/components/server/server-detail-footer.vue' //阿姨详情 - 页脚
import serverOrderList from '../shared/components/server/order-list.vue' //阿姨 - 历史订单
//添加|编辑服务人员信息
import serverProfile from '../shared/components/server/server-profile.vue'
import serverProfileNew from '../shared/components/server/server-profile-new.vue'
//代下单发布
import releaseClientJobConfirm from '../shared/components/client/release/releaseClientJobConfirm.vue' //代下单 - 客户 - 确认面板
import releaseClientJob from '../shared/components/client/release/clientJob.vue' //代下单 - 客户 - 发布订单
import releaseJobResult from '../shared/components/client/release/result.vue' //发布订单 - 发布普通订单 - 结果
//帮助
import userHelpDetailPanel from '../shared/components/service/help-detail.vue' //用户中心 - 帮助中心 - 详情面板
//下载着陆页
import downloadLanding from '../shared/components/download/download-landing.vue'

//跨平台 - 公用组件 - 控件组件
import pubHeader from '../shared/components/header.vue' //公用页头
import headTab from '../shared/components/head-tab.vue' //顶部Tab
import search from '../shared/components/search.vue' //搜索框
import star from '../shared/components/star.vue' //星星
import checkbox from '../shared/components/checkbox.vue' //复选框
import selector from '../shared/components/selector.vue' //下拉框
import selectList from '../shared/components/selectList.vue' //下拉框
import field from '../shared/components/control/field.vue' //内容显示、输入、跳转操作面板
import panelFull from '../shared/components/control/panel-full.vue' //全覆面板
import panelDown from '../shared/components/control/panel-down.vue' //面板 - 底部
import menuPopupRightTop from '../shared/components/control/menu-popup-righttop.vue' //菜单 - 弹出 - 右上角
import chooseImagePanel from '../shared/components/control/choose-image.vue' //选择照片面板
import worktypePanel from '../shared/components/job/worktype-panel.vue' //工作类型选择面板
import servicetypePanel from '../shared/components/job/servicetype-panel.vue' //服务内容选择面板
import iosselect from '../shared/components/iosselect/iosSelect.vue' //仿IOS滚轮选择器
import upload from '../shared/components/uploadfile/upload.vue' //上传文件
import downloadGuideBar from '../shared/components/download/download-guide-bar.vue' //下载引导条

//跨平台 - 公用组件 - 工具组件
import toast from '../shared/service/toast.js'
import dialogAlert from '../shared/components/dialog/alert.vue'
import uAlert from '../shared/components/dialog/alert.js' //弹出框 - 提示|确认|分享
import tool from '../shared/service/tool.js' //工具
import awesomeSwiper from '../shared/components/swiper/awesome-swiper.vue' //滑动
import zoom from '../shared/components/zoom/zoom.vue' //放大


Vue.config.productionTip = false;

Vue.component("footer-tab", footerTab);
Vue.component("page-head", head);

Vue.component("pub-header", pubHeader);
Vue.component("head-tab", headTab);
Vue.component("search", search);
Vue.component("star", star);
Vue.component("checkbox", checkbox);
Vue.component("selector", selector);
Vue.component("select-list", selectList);
Vue.component("field", field);
Vue.component("panel-full", panelFull);
Vue.component("panel-down", panelDown);
Vue.component("menu-popup-righttop", menuPopupRightTop);
Vue.component("choose-image", chooseImagePanel);
Vue.component("worktype-panel", worktypePanel);
Vue.component("servicetype-panel", servicetypePanel);
Vue.component("iosselect", iosselect);
Vue.component("dialog-alert", dialogAlert);

Vue.component("server-detail", serverDetail);
Vue.component("server-detail-footer", serverDetailFooter);
Vue.component("server-order-list", serverOrderList);
Vue.component("server-profile", serverProfile);
Vue.component("server-profile-new", serverProfileNew);

Vue.component("release-jobresult", releaseJobResult);
Vue.component("release-clientjob-confirm", releaseClientJobConfirm);
Vue.component("release-clientjob", releaseClientJob);

Vue.component("user-helpdtail-panel", userHelpDetailPanel);
Vue.component("download-landing", downloadLanding);

Vue.component("awesome-swiper", awesomeSwiper);
Vue.component("zoom", zoom);
Vue.component("upload", upload);
Vue.component("download-guide-bar", downloadGuideBar);

Vue.use(uAlert);
Vue.use(toast);
Vue.use(service);
Vue.use(ElementUI);
Vue.use(tool);

new Vue({
    el: '#app',
    router,
    // store,
    components: { App },
    template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/ally/main.js